import styles from "./status.module.css";
import * as status from "./statuses";

const Status = ({ children }) => {
  switch (children) {
    case status.PENDING_RECEIPT:
    case status.DIAGNOSTICS_PERFORMED:
    case status.QUARANTINE_HOLD:
    case status.DEVICE_CONVERSION:
    case status.CHARGING_STAGING:
    case status.CHARGING:
    case status.CONVERSION_STAGING:
    case status.RECEIVING_IN_PROGRESS:
      return (
        <div className={styles.statusPending}>
          <div className={styles.statusChildPending} />
          <div className={styles.inProgressPending}>{children}</div>
        </div>
      );
    case status.PHYSICAL_DAMAGE:
    case status.SCREEN_BURN:
    case status.RETURN_TO_CUSTOMER:
    case status.LOST_IN_TRANSIT:
    case status.SENT_BACK_TO_PARTNER:
    case status.NOT_DEVLIVERED:
      return (
        <div className={styles.statusCanceled}>
          <div className={styles.statusChildCanceled} />
          <div className={styles.inProgressCanceled}>{children}</div>
        </div>
      );
    case status.TRADE_IN_COMPLETED:
    case status.VALUATION_COMPLETED:
    case status.DEVICE_RECEIVED:
      return (
        <div className={styles.statusCompleted}>
          <div className={styles.statusChildCompleted} />
          <div className={styles.inProgressCompleted}>{children}</div>
        </div>
      );

    default:
      return (
        <div className={styles.statusPending}>
          <div className={styles.statusChildPending} />
          <div className={styles.inProgressPending}>{children}</div>
        </div>
      );
  }
};

export default Status;
